import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const AdvertiserIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.7998 9.71094C8.90437 9.71094 9.7998 8.81551 9.7998 7.71094C9.7998 6.60637 8.90437 5.71094 7.7998 5.71094C6.69524 5.71094 5.7998 6.60637 5.7998 7.71094C5.7998 8.81551 6.69524 9.71094 7.7998 9.71094Z"
          fill="#ADACA8"
          stroke="#ADACA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.08887 5.71C1.76087 3.452 3.54087 1.672 5.79887 1"
          stroke="#ADACA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.7998 1C12.0578 1.672 13.8378 3.452 14.5098 5.71"
          stroke="#ADACA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5098 9.71094C13.8378 11.9689 12.0578 13.7489 9.7998 14.4209"
          stroke="#ADACA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.79887 14.4209C3.54087 13.7489 1.76087 11.9689 1.08887 9.71094"
          stroke="#ADACA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

export default AdvertiserIcon
